var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.user
    ? _c(
        "div",
        { staticClass: "p-3" },
        [
          _c(
            "b-card",
            { attrs: { title: "Konfigurasi Master Loket" } },
            [
              _c(
                "b-card-text",
                [
                  _c(
                    "b-button",
                    {
                      staticClass: "btn-sm",
                      attrs: { variant: "primary" },
                      on: { click: _vm.addMasterLoket },
                    },
                    [
                      _c("b-icon", { attrs: { icon: "plus" } }),
                      _vm._v(" Tambah Data"),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "mt-3",
                    attrs: { id: "tabledata-master-loket" },
                  }),
                  _vm._v(" "),
                  _vm.table
                    ? _c("div", { staticClass: "row mt-5" }, [
                        _c("div", { staticClass: "col" }, [
                          _vm._v(
                            "\n                    Showing " +
                              _vm._s(_vm.paging_data.from) +
                              " to " +
                              _vm._s(_vm.paging_data.to) +
                              " of " +
                              _vm._s(_vm.paging_data.total) +
                              " entries\n                "
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col" },
                          [
                            _vm.total_rows > 0
                              ? _c("b-pagination", {
                                  attrs: {
                                    "per-page": _vm.item_per_page,
                                    "total-rows": _vm.total_rows,
                                    "prev-text": "Prev",
                                    "next-text": "Next",
                                    align: "center",
                                  },
                                  on: { "page-click": _vm.pageClick },
                                  model: {
                                    value: _vm.page,
                                    callback: function ($$v) {
                                      _vm.page = $$v
                                    },
                                    expression: "page",
                                  },
                                })
                              : _vm._e(),
                          ],
                          1
                        ),
                      ])
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }